import axios, { AxiosResponse } from "axios";
import { Report, ReportEditRequest } from "../../models/Reports";

export const getReportsList = (productId: string) => async (): Promise<AxiosResponse<Report[]>> => {
	return await axios.get(`/api/v1/${productId}/reports`);
};

export const getReport = (productId: string, reportId: string) => async (): Promise<AxiosResponse<Report>> => {
	return await axios.get(`/api/v1/${productId}/reports/${reportId}`);
};

export const editReport = (productId, report: ReportEditRequest) => async (): Promise<AxiosResponse> => {
	return await axios.put(`/api/v1/${productId}/reports`, report);
};

export const createReport = (productId, report: ReportEditRequest) => async (): Promise<AxiosResponse> => {
	return await axios.post(`/api/v1/${productId}/reports`, report);
};

export const deleteReport = (productId, reportId: string) => async (): Promise<AxiosResponse> => {
	return await axios.delete(`/api/v1/${productId}/reports/${reportId}`);
};
